import { getContentfulClient } from './client';
import { resolveAssetUrl, unwrapField, unwrapLinkField } from './utils';

const CONTENT_TYPE_SPONSOR_LOGOS = 'sponsorLogosForScroll';
const STATUS_ACTIVE = 'Active';

/**
 * Fetches sponsor logos for the home page (and other) marquee from Contentful.
 * Only entries with status "Active" are included.
 * @returns {Promise<Array<{ id: string, src: string, alt: string }>>} ordered list, or [] if misconfigured
 */
export async function fetchSponsorLogosForScroll() {
  const client = getContentfulClient();
  if (!client) {
    return [];
  }

  const limit = 100;
  let skip = 0;
  const out = [];
  const assetsById = new Map();

  for (;;) {
    const response = await client.getEntries({
      content_type: CONTENT_TYPE_SPONSOR_LOGOS,
      'fields.status': STATUS_ACTIVE,
      limit,
      skip,
      order: 'sys.createdAt',
      include: 10,
    });

    const includedAssets = response.includes?.Asset || response.includes?.asset || [];
    includedAssets.forEach((a) => {
      if (a?.sys?.id) assetsById.set(a.sys.id, a);
    });

    for (const entry of response.items || []) {
      const f = entry.fields || {};
      const status = unwrapField(f.status);
      if (String(status ?? '').trim() !== STATUS_ACTIVE) {
        continue;
      }
      const sponsorName = unwrapField(f.sponsorName);
      const logoUrl = resolveAssetUrl(unwrapLinkField(f.sponsorLogo), assetsById);
      if (!logoUrl) {
        continue;
      }
      out.push({
        id: entry.sys.id,
        src: logoUrl,
        alt: typeof sponsorName === 'string' && sponsorName.trim() ? sponsorName.trim() : 'Sponsor',
      });
    }

    if ((response.items || []).length < limit) {
      break;
    }
    skip += limit;
  }

  return out;
}
